import { StrategyDuration } from "@bridgesplit/abf-sdk";

import { Replace } from "../../reducers";
import { ApiParsedLoanEvent } from "../api";

export type ParsedLoanEvent = Replace<ApiParsedLoanEvent, { actionMetadata: ParsedLoanEventActionMetadata }>;

export enum LoanEventActionType {
    AddCollateral = "addCollateral",
    RemoveCollateral = "removeCollateral",
    BorrowPrincipal = "borrowPrincipal",
    RepayPrincipal = "repayPrincipal",
    RefinanceLedger = "refinanceLedger",
    SellLedger = "sellLedger",
    Liquidate = "liquidate"
}

export type ParsedLoanEventActionMetadata =
    | { type: LoanEventActionType.AddCollateral; params: null }
    | { type: LoanEventActionType.RemoveCollateral; params: null }
    | { type: LoanEventActionType.BorrowPrincipal; params: ParsedBorrowPrincipalMetadata }
    | { type: LoanEventActionType.RepayPrincipal; params: ParsedRepayPrincipalMetadata }
    | { type: LoanEventActionType.RefinanceLedger; params: ParsedRefinanceLedgerMetadata }
    | { type: LoanEventActionType.SellLedger; params: ParsedSellLedgerMetadata }
    | { type: LoanEventActionType.Liquidate; params: ParsedLiquidateLedgerMetadata };

export interface ParsedBorrowPrincipalMetadata {
    preBorrowPrincipalLedgerState: ParsedEventLedger;
    postBorrowPrincipalLedgerState: ParsedEventLedger;
}

export interface ParsedRepayPrincipalMetadata {
    preRepaymentPrincipalLedgerState: ParsedEventLedger;
    postRepaymentPrincipalLedgerState: ParsedEventLedger;
}

export interface ParsedRefinanceLedgerMetadata {
    preRefinanceLedgerState: ParsedEventLedger;
    postRefinanceLedgerState: ParsedEventLedger;
}

export interface ParsedSellLedgerMetadata {
    buyer: string;
    seller: string;
}

export enum LiquidateEventType {
    LiquidatedCollateral,
    CollateralReturned
}

export interface ParsedLiquidatedCollateralMetadata {
    amount: number;
    assetMint: string;
    toLiquidator: boolean;
    price: number;
    liquidateEventType: LiquidateEventType;
}

export interface ParsedLiquidateLedgerMetadata {
    ledgerIndex: number;
    isTimeBasedLiquidation: boolean;
    liquidationFee: number;
    collateralTransfers: ParsedLiquidatedCollateralMetadata[];
}

export interface ParsedEventLedger {
    ledgerIndex?: number; // optional, not always present in domain
    status: number; // u8 as number
    strategy: string;
    principalMint: string;
    marketInformation: string;
    principalDue: number; // u64 as number
    principalRepaid: number; // u64 as number
    interestOutstanding: number; // u64 as number
    duration: StrategyDuration;
    interestPerSecond: number; // f64 as number
    apy: number; // u64 as number
    endTime: number; // u64 as number
    startTime?: number; // optional, in API
}
